export default __webpack_public_path__ + "static/media/prodMeta.6ef666de.png";